import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Row } from 'reactstrap';
import 'rc-pagination/assets/index.css';
import Pagination from 'rc-pagination';
import { getSystemLogs } from '../../../actions/SystemLogs';
import SetLimitEntries from '../../../components/SetLimitEntries';
import ViewMore from '../../../components/ViewMore';
import { ENG_LOCALE } from '../../../lib/constants';
import logoLoading from '../../../Res/logo-loading.gif';
import SortIcons from '../../../components/ProposalsSortIcons';
import utils from '../../../lib/utils';

const SystemLogTable = ({filters}) => {
  const dispatch = useDispatch();
  const token = localStorage.getItem('jwtToken') || null;

  const [loading, setLoading] = useState(false);
  const [listData, setListData] = useState([]);
  const [sortValue, setSortValue] = useState({
    name: '',
    order: '',
  });

  const data = useSelector(state => state.AppState.boxDetails.getSystemLogsSuccess) || [];
  useEffect(() => {
    setListData(data);
  }, [data])

  const onSystemLogs = async pagination => {
    setLoading(true);
    const result = await dispatch(getSystemLogs(token, pagination, filters));
    setListData(result);
    setLoading(false);
  };

  useEffect(() => {
    const pagination = { page: 1, limit: 10, sort: { createdAt: -1 } };
    onSystemLogs(pagination);
  }, []);

  const handleSetLimit = limit => {
    setLoading(true);
    onSystemLogs({ page: 1, limit, sort: { createdAt: -1 } });
    setLoading(false);
  };

  const handleChangePagination = page => {
    const { limit } = listData;
    // setFilterPage(page);
    const pagination = { page, limit, sort: { createdAt: -1 } };
    setLoading(true);
    onSystemLogs(pagination);
    setLoading(false);
  };

  const onSort = name => {
    const { order } = sortValue;
    const newOrder = order === 'asc' ? 'desc' : 'asc';
    setSortValue({ name, order: newOrder });
    const dbSort = { sort: { [name]: newOrder === 'asc' ? 1 : -1 } };
    const pagination = { page: listData.page, limit: 10, ...dbSort };
    onSystemLogs(pagination);
  };

  const sortColumnByKey = data => {
    const { name, order } = sortValue;
    if (name && order) {
      return data.sort((a, b) => {
        if (order === 'asc') {
          return a[name] > b[name] ? 1 : -1;
        }
        return a[name] < b[name] ? 1 : -1;
      });
    }
    return data;
  };

  return loading ? (
    <div className="error-msg d-flex flex-column justify-content-center align-items-center">
      <img src={logoLoading} className="loading-logo-sm" alt="loading" />
      <p className="text-align-center">Loading, Please wait...</p>
    </div>
  ) : (
    <>
      <div className="table-header-fixed">
        <table>
          <thead>
            <tr>
              <th className="cursor-pointer">Users</th>
                <th className="cursor-pointer">Company</th>
              <th className="cursor-pointer" style={{ width: '300px' }}>
                Actions
              </th>
              <th className="cursor-pointer" onClick={() => onSort('createdAt')}>
                Created At
                <SortIcons sortObj={sortValue} sortName="createdAt" />{' '}
              </th>
            </tr>
          </thead>
          <tbody>
            {sortColumnByKey(listData?.docs)?.map((element, ind) => {
              return (
                <tr key={ind}>
                  <td>{element?.user?.name || '-'}</td>
                  <td>{element?.company || '-'}</td>
                  <td className="action-description">
                    <ViewMore element={element} />
                  </td>
                  <td>
                    {utils.getDateTimeFormat(element?.createdAt, 'both')}
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
      {listData && listData?.docs?.length > 0 ? (
        <Row className="justify-content-md-center">
          <SetLimitEntries value={10} onChange={handleSetLimit} />
          <Pagination
            locale={ENG_LOCALE}
            className="pagination-container"
            onChange={handleChangePagination}
            current={listData.page}
            total={listData.totalDocs}
            pageSize={listData.limit}
            showLessItems
            showTitle={false}
            showTotal={(total, range) => `${range[0]} - ${range[1]} of ${total} items`}
          />
        </Row>
      ) : (
        <Row className="justify-content-md-center">
          <div className="select-limit">No logs found</div>
        </Row>
      )}
    </>
  );
};

export default SystemLogTable;
